"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bdd = void 0;
const util_endpoints_1 = require("@smithy/util-endpoints");
const m = "ref";
const a = -1, b = true, c = "isSet", d = "PartitionResult", e = "booleanEquals", f = "getAttr", g = "stringEquals", h = { [m]: "Endpoint" }, i = { [m]: d }, j = { [m]: "Region" }, k = {}, l = [j];
const _data = {
    conditions: [
        [c, [h]],
        [c, l],
        ["aws.partition", l, d],
        [e, [{ [m]: "UseFIPS" }, b]],
        [e, [{ [m]: "UseDualStack" }, b]],
        [e, [{ fn: f, argv: [i, "supportsDualStack"] }, b]],
        [e, [{ fn: f, argv: [i, "supportsFIPS"] }, b]],
        [g, [j, "us-gov-east-1"]],
        [g, [j, "us-gov-west-1"]]
    ],
    results: [
        [a],
        [a, "Invalid Configuration: FIPS and custom endpoint are not supported"],
        [a, "Invalid Configuration: Dualstack and custom endpoint are not supported"],
        [h, k],
        ["https://logs-fips.{Region}.{PartitionResult#dualStackDnsSuffix}", k],
        [a, "FIPS and DualStack are enabled, but this partition does not support one or both"],
        ["https://logs.us-gov-east-1.amazonaws.com", k],
        ["https://logs.us-gov-west-1.amazonaws.com", k],
        ["https://logs-fips.{Region}.{PartitionResult#dnsSuffix}", k],
        [a, "FIPS is enabled but this partition does not support FIPS"],
        ["https://logs.{Region}.{PartitionResult#dualStackDnsSuffix}", k],
        [a, "DualStack is enabled but this partition does not support DualStack"],
        ["https://logs.{Region}.{PartitionResult#dnsSuffix}", k],
        [a, "Invalid Configuration: Missing Region"]
    ]
};
const root = 2;
const r = 100_000_000;
const nodes = new Int32Array([
    -1, 1, -1,
    0, 14, 3,
    1, 4, r + 13,
    2, 5, r + 13,
    3, 8, 6,
    4, 7, r + 12,
    5, r + 10, r + 11,
    4, 12, 9,
    6, 10, r + 9,
    7, r + 6, 11,
    8, r + 7, r + 8,
    5, 13, r + 5,
    6, r + 4, r + 5,
    3, r + 1, 15,
    4, r + 2, r + 3,
]);
exports.bdd = util_endpoints_1.BinaryDecisionDiagram.from(nodes, root, _data.conditions, _data.results);
